import { StyleEntry } from 'Shared/backend/styleUtils';
import { Borders } from 'Shared/backend/widgets/Borders';
import { Margins } from 'Shared/backend/widgets/Margins';
import { Padding } from 'Shared/backend/widgets/Padding';
import { Brightness } from 'Shared/themes/Brightness';
import { Colour } from 'Shared/themes/Colour';


export function customStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		Brightness: {
			explanation: 'Change the brightness of an image.',
			ui: Brightness,

			rules: [{
				location: () => ['**','image'],
				css: (params) => ({
					filter: `brightness(${params.brightness}%)`
				}),
			}]
		},

		Colour: {
			explanation: 'Set the foreground colour.',
			//explanation: 'Set the foreground colour. Note this property is automatically inherited in CSS.',  XXX in practice title styling is often likely to override
			ui: Colour,

			rules: [{
				location: (params = {}) => selectLocation(params?.selector),
				css: (params) => ({
					color: params.colour
				}),
			}]
		},

		'Background colour': {
			explanation: 'Set the background colour.',
			ui: Colour,

			rules: [{
				location: (params = {}) => selectLocation(params?.selector),
				css: (params) => ({
					background: params.colour
				}),
			}]
		},

		'Centre object': {
			explanation: 'Centers the contents vertically and horizontally within its parent.',

			rules: [{
				location: () => ['*'],
				css: () => ({
					height: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				})
			}]
		},

		//XXX use in The Townie club page description. Should descriptions be left justified by default?
		'Left align': {
			explanation: 'Aligns the text to the left. Note children inherit text aligment by default.',

			rules: [{
				location: () => ['*'],
				css: () => ({
					textAlign: 'left'
				})
			}]
		},

		'Margins': {
			explanation: 'Add margins.',

			ui: Margins,

			initial: {
				margin: { sides: 'different' }
			},

			rules: [{
				location: (params = {}) => selectLocation(params?.selector),
				margin: (params = {}) => params?.margin,
			}]
		},

		'Padding': {
			explanation: 'Add padding to the children.',

			ui: Padding,

			initial: {
				padding: { sides: 'different' }
			},

			rules: [{
				location: (params = {}) => selectLocation(params?.selector),
				padding: (params = {}) => params?.padding,
			}]
		},

		'Borders': {
			explanation: 'Add borders to the children.',

			ui: Borders,

			initial: {
				border: { sides: 'all',all:{ style:'solid',colour:'gray',width:'2px' }}
			},

			rules: [{
				location: (params = {}) => selectLocation(params?.selector),
				border: (params = {}) => params?.border,
			}]
		},
	};
}

function selectLocation(selector:'self'|'children'|'all'|undefined)
{
	if (!selector)
		return ['*'];

	switch (selector) {
		case 'self': return ['*'];
		case 'children': return ['*','*'];
		case 'all': return ['**'];
	}
}

